import { render, staticRenderFns } from "./Instructions2022.vue?vue&type=template&id=19a85e40&scoped=true"
import script from "./Instructions2022.vue?vue&type=script&lang=js"
export * from "./Instructions2022.vue?vue&type=script&lang=js"
import style0 from "./Instructions2022.vue?vue&type=style&index=0&id=19a85e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a85e40",
  null
  
)

export default component.exports